module.exports = __webpack_public_path__ + "img/ss2.bdd7b51a.gif";